/*
 * Copyright (c) 2024-2026. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this content, please contact the author for proper authorization and agreement.
 */
import React from 'react'
import clsx from 'clsx'

interface TableHeadRowProps {
    children: React.ReactNode | React.ReactNode[]
    className?: string
}

const TableHeadRow = ({ children, className }: TableHeadRowProps) => {
    return (
        <tr className={clsx('TableHeadRow', className)}>
            {children}
        </tr>
    )
}

export default TableHeadRow
